/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Deactivateall_Typetoconfirm5Inputs */

const en_settings_reportingapikeys_deactivateall_typetoconfirm5 = /** @type {(inputs: Settings_Reportingapikeys_Deactivateall_Typetoconfirm5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type DEACTIVATE to confirm`)
};

/**
* | output |
* | --- |
* | "Type DEACTIVATE to confirm" |
*
* @param {Settings_Reportingapikeys_Deactivateall_Typetoconfirm5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_deactivateall_typetoconfirm5 = /** @type {((inputs?: Settings_Reportingapikeys_Deactivateall_Typetoconfirm5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Deactivateall_Typetoconfirm5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_deactivateall_typetoconfirm5(inputs)
});
export { settings_reportingapikeys_deactivateall_typetoconfirm5 as "settings_reportingApiKeys_deactivateAll_typeToConfirm" }